import React, { useEffect, useState } from 'react';
import SimpleBarChart from './charts/SimpleBarChart';

function ProductVsFeedChart({ start, end }) {
  const [totals, setTotals] = useState({ feed: 0, product: 0 });

  useEffect(() => {
    if (!start || !end) return;
    fetch(`/api/overall-yield.php?start=${start}&end=${end}`)
      .then(res => res.json())
      .then(res => {
        setTotals({
          feed: res.total_feed || 0,
          product: res.total_product || 0,
        });
      })
      .catch(() => setTotals({ feed: 0, product: 0 }));
  }, [start, end]);

  const calcStep = val => {
    if (val === 0) return 1;
    const rough = val / 5;
    const pow = Math.pow(10, Math.floor(Math.log10(rough)));
    const mults = [1, 2, 5, 10];
    for (const m of mults) {
      if (rough <= m * pow) return m * pow;
    }
    return 10 * pow;
  };

  const maxVal = Math.max(totals.feed, totals.product);
  const step = calcStep(maxVal);
  const tickCount = Math.ceil(maxVal / step);
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => +(i * step).toFixed(2));
  const maxAxis = tickCount > 0 ? ticks[ticks.length - 1] : step;

  return (
    <SimpleBarChart
      height={160}
      data={[
        {
          label: 'Total Feed to Plant',
          value: totals.feed,
          color: '#22c55e',
          display: totals.feed.toFixed(2),
          valueInside: true,
        },
        {
          label: 'Total Product Tonnage',
          value: totals.product,
          color: '#3b82f6',
          display: totals.product.toFixed(2),
          valueInside: true,
        },
      ]}
      max={maxAxis}
      ticks={ticks}
      valueClass="text-sm font-bold"
      labelFontSize={14}
      labelBold
    />
  );
}

export default ProductVsFeedChart;
